var options = [];
var skuList = [];
// var sku_number = productJson["handle"].match(/\d+(\.\d+)?/g)[0];
var variantKeyMap = {};
var currentSkuVariant={};
// let url = `https://searchserverapi.com/getresults?api_key=1J5r3X3Z6u&q=${sku_number}&sortBy=relevance&sortOrder=desc&startIndex=0&maxResults=50&items=true&pages=true&categories=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=20&categoryStartIndex=0&categoriesMaxResults=20&facets=true&facetsShowUnavailableOptions=false&recentlyViewedProducts=7898991886578%2C6770676105416%2C7898986709234%2C7888716595442%2C7884610601202%2C7902067327218%2C7884610502898&ResultsTitleStrings=2&ResultsDescriptionStrings=2&timeZoneName=Asia%2FShanghai&output=jsonp&_=1681619285382`;
initProductAttribute();
function initProductAttribute() {
    //如果当前产品是戒指就不执行之前sku分组属性处理
    if(productJson['type'] == 'rings'){
      return;
    }
    // let { items } = await fetch(url).then((data) => { return data.json() });
    let items = product_with_sku_json;
    console.log("items");
    console.log(product_with_sku_json);
    items.forEach((item) => {  
        if(variant_color_write_list.includes(productJson.variants[0]["sku"]) && item.variant[0]["sku"] != productJson.variants[0]["sku"]){
            return;
        }
        if(item.variant[0]["sku"] != productJson.variants[0]["sku"] && variant_color_write_list.includes(item.variant[0]["sku"])){
          return;
        }
        sku = item.variant[0].sku;
        skuList[`${sku}`] = item.variant[0];
        skuList[`${sku}`]['options'] = {};
        item.options.forEach((option)=>{
            let key = option['name'];
            let value = option['values'][0];
            if (option['name'] == "Title") return;
            if (!options.hasOwnProperty(key)) { options[key] = [] }
            skuList[`${sku}`]['options'][key] = value;
            console.log(options);
            if (options[key].indexOf(value) == -1) {
                console.log("key:"+key);
                options[key].push(value);
            }
        });
    });
    initHtml();
    variantInit();
    initValueMap(skuList);
    checkNoSku();
}

function initHtml(){
  let html = "";
  for (let key in options) {
    if(["Finish","Stone Color","Enamel Color","Leather Color"].includes(key)){
      html += `<div id="div_${key.replace(" ","_")}" style="border-top:1px solid #ccc;padding: 5px 0;"><header style="margin-bottom: 10px;font-weight:800;">${key}:</header><section class="colour_section">`;
    }else if(key == "Metal"){
      html += `<div id="div_${key}" style="border-top:1px solid #ccc;padding: 5px 0;"><header style="margin-bottom: 10px;font-weight:800;">Select Metal:</header><section>`;
    }else if(["Bracelet Size","Necklace Size","Ring Size"].includes(key)){
      if(key == "Bracelet Size"){
        html += `<div id="div_${key.replace(' ','_')}" style="border-top:1px solid #ccc;padding: 5px 0;"><header style="margin-bottom: -5px;position:relative;font-weight:800;">${key}:
          <span style="display: inline-block;position:absolute;right: 5px;">
          <i style="
    display: inline-block;
    width: 12px;
    height: 12px;
    background: #000;
    vertical-align: middle;
    border-radius: 12px;
    color: #fff;
    text-align: center;
    font-size: 0.6em;
    font-style: normal;
">!</i>
          <a href="javascript:void(0)" onclick="openBraceletModal()" style="    
    color: #000;
    text-decoration-line: none;
">Size Guide</a>
          </span>
        </header>
        <span style="color:red;font-size:12px;">&nbsp;(Tips: Size up for 5+ charms bracelets.)</span>
        <section>`;
      }else{
        html += `<div id="div_${key.replace(' ','_')}" style="border-top:1px solid #ccc;padding: 5px 0;"><header style="margin-bottom: 10px;">${key}</header><section>`;
      }
    }else{
      html += `<div id="div_${key}" style="border-top:1px solid #ccc;padding: 5px 0;font-weight:800;"><header >${key}</header><section>`;
    }
    if(key.indexOf('Size')!= -1){
      options[key] = options[key].sort();
    }
    options[key].forEach((v) => {
      if (["Finish","Stone Color","Enamel Color","Leather Color"].includes(key)) {
        let color_short_name = getColourShortName(v);
        html += `<div class="Colour_span ${key.replace(" ","_")}_span"><span  class="color" id="${v}" type="${key}"> </span><div id="t_${v}">${color_short_name}</div></div>`;
      } else {
        if(key == "Metal"){
            let value = v;
          let = ``;
           if(v.indexOf('S925 & S180') != -1){
             value = v;
           }else if(v.indexOf('S925')!= -1){
             value = `Sterling Silver(S925)`;
           }else if(v.indexOf("S180")!= -1){
             value = `Tarnish-Resistant Silver(S180)`;
           }else{
             value = v;
           }
          html += `<div class="${key}_span"><span  id="${v}" type="${key}"> ${value} </span></div>`;
        }else{
           html += `<div class="${key}_span"><span  id="${v}" type="${key}"> ${v} </span></div>`;
        }
      }
    });
    html += `</section></div>`;
  }
  // let product_metal = $("#gongMetal").val();
  if($("#gongMetal").val()){
    product_metal = $("#gongMetal").val();
  }
  let metal_html = '';
  if(!Object.keys(options).includes("Metal")){
      metal_html = `<div style="border-top: 1px solid #ccc;padding: 10px 0;"><span style="font-weight:800;">Metal:&nbsp;</span>${product_metal}<span onclick="openModal()" class="metal-info">?</span></div>`;
  }
  html += metal_html;
  console.log("html");
  console.log(html);
  if(!document.querySelector(".rio-options")){
    $("variant-radios").before("<div class='rio-options' style='width:100%'></div>");
  }
  document.querySelector(".rio-options").innerHTML = html;
  console.log("inner html");
  initColor();
  addMetalIntroduce();
  document.querySelector("variant-radios").style.display="none";
  initVariantShow();
  document.querySelectorAll(".rio-options section span").forEach((item) => {
    item.addEventListener("click", function () {
      console.log("click:"+item.className.indexOf('active'));
      let cancel = false;
      if(item.className.indexOf('active')> -1){
        item.classList.remove("active");
        cancel = true;
      }else{
        item.classList.add("active");
      }
      selectSku(item,cancel);
    });
  });
}

function initColor(){
  document.querySelectorAll(".Colour_span span").forEach((item) => {
    console.log("color");
    let color = item.getAttribute("id");
    color = color.trim(" ");
    // let color_value = variant_color_config[color];
    let color_value = getColorValue(color,item.getAttribute("type"));
    if (color_value && color_value.indexOf("cdn.shopify") != -1) {
      item.style.background = `url(${color_value})`;
      item.style.backgroundRepeat = "no-repeat";
      item.style.backgroundPosition = "center center";
      item.style.backgroundSize = "cover";
    } else {
      item.style.background = color_value;
    }
    console.log('=================+++++++++++++'+color_value);
    
  });
}

function  getColourShortName(colour_full_name){
  console.log("get_colour_short_name:"+colour_full_name);
  if(color_name_to_short_config.hasOwnProperty(`${colour_full_name}`)){
    return color_name_to_short_config[`${colour_full_name}`];
  }else{
    return colour_full_name;
  }
}

function initVariantShow(){
  for (let key in options) {
        try{
          if(['Metal',"Finish","Stone Color","Enamel Color","Leather Color","Bracelet Size","Necklace Size","Ring Size"].includes(key))continue;
          if(document.querySelectorAll(`.rio-options span[type="${key}"]`).length >= 1 && document.querySelectorAll(`.rio-options span[type="${key}"]`).length <= 1){
              document.querySelector(`div[id="div_${key}"`).style.display='none';
          }
        }catch(e){}
    }
}

function addMetalIntroduce(){
  let introduce_html = `
  <div id="tip_box" style="height: auto;
    position: relative;cursor: crosshair;bottom: 5px;"><a href="javascript:void(0);" data-href="https://gona.com/pages/zsed#silver" onclick="openModal()" style="
   display: inline-block;
    width: 25px;
    height: 25px;
    background: #c4c3c4;
    color: #29292a;
    border-radius: 50%;
    line-height: 25px;
    text-decoration: none;
    position: absolute;
    bottom: 3px;
    font-weight: 600;
    font-size: 19px;
">?</a></div>
  `;
  $(".Metal_span").last().after(introduce_html);
}

function initValueMap(skuList) {
    for (let key in skuList) {
        let item = skuList[key];
        let variantOption = item.options;
        let variantKey = getSkuVariantKey(variantOption);
        variantKeyMap[`${variantKey}`] = item['sku'];
    }
    console.log(variantKeyMap);
}


function getSkuVariantKey(variantOption = null) {
    let variantKey = "";
    if (!variantOption) {
       variantOption = currentSkuVariant
    }
    for (let key in variantOption) {
        variantKey += key+'_'+variantOption[key]
    }
    return variantKey;
}

function initCurrentSKuVariantKey() {
    productJson.options.forEach((key, index) => {
        currentSkuVariant[`${key}`] = productJson.variants[0].options[index];
        document
          .querySelectorAll(".rio-options span[type='" + key + "']")
          .forEach((item) => {
            item.classList.remove("active");
            if (item.getAttribute("id") == productJson.variants[0].options[index]) {
              item.classList.add("active");
            }
          });
    });
}

function selectSku(_this,cancel=false) {
    let key = _this.getAttribute("type");
    let value = _this.getAttribute("id");
    variantSelect(key, value,cancel);
    currentSkuVariant = {};
    $(".rio-options .active").each(function(){
      console.log($(this).attr('id')+' '+$(this).attr("type"));
      let key = $(this).attr("type");
      let value = $(this).attr("id");
      currentSkuVariant[`${key}`] = value;
    });
  
    let variantKey = getSkuVariantKey();
    console.log(`selectSku:variantKey:key:${key} value:${value} ${variantKey}`);
    console.log(currentSkuVariant);
    if (variantKeyMap.hasOwnProperty(variantKey)) {
      let sku = skuList[`${variantKeyMap[`${variantKey}`]}`];
      console.log(`selectSku:sku:${sku}`);
      if (sku["sku"].toLowerCase() != productJson["handle"].replace('-','.').toLowerCase()) {
        location.href = `/products/${sku["sku"].replace('.','-')}`;
        return;
      }
    }
    autoLocationSku(key);
    //检查缺货的sku
    checkNoSku();
}

function autoLocationSku(currontKey){
  console.log("autoLocationSku");
    var selectedKey = [];
  //1.拿到当前已经选中的属性值
    $("span.active").each(function(){
        let type =$(this).attr("type");
        let value = $(this).attr("id");
        let key = `${type}_${value}`;
        if(type == currontKey){
          selectedKey.unshift(key);
        }else{
          selectedKey.push(key);
        }
    });
  console.log(selectedKey);
  //2.到valueMap里面遍历作比较如果只有唯一的一条就跳转
    var containsVariantKey = [];
    var tmpVariantKeyKeys = Object.keys(variantKeyMap);
    selectedKey.forEach(key=>{
        tmpVariantKeyKeys.forEach(k=>{
            if(k.indexOf(key)!= -1){
                if(!containsVariantKey.includes(k)){
                    containsVariantKey.push(k);
                }
            }
        })
        console.log(containsVariantKey);
        tmpVariantKeyKeys = containsVariantKey;
        if(containsVariantKey.length == 1){
            sku = variantKeyMap[containsVariantKey[0]];
            console.log("autoLocationSku:"+sku);
            if(sku != productJson.variants[0].sku){
              sku = sku.replace(".","-");
              location.href = `/products/${sku}`;
              return;
            }
        }
        containsVariantKey = [];
    })  
}
  
// 检查缺货sku
function checkNoSku() { 
  document.querySelectorAll(".rio-options section div>span").forEach((item)=>{
     item.style.color = '#000';
      item.style.textDecoration='none';
  });
  document.querySelectorAll(".rio-options section .Colour_span div").forEach((item)=>{
     item.style.color = '#000';
      item.style.textDecoration='none';
  });
    for (let key in options) {
        document.querySelectorAll(".rio-options span[type='" +key + "']").forEach((item) => {
            // var tmpCurrentSkuVarirant = currentSkuVariant;
            // console.log("checkNoSku...");
            // tmpCurrentSkuVarirant[`${key}`] = item.getAttribute("id");
            // s = getSkuVariantKey(tmpCurrentSkuVarirant);

            s = '';
            Object.keys(options).forEach((k)=>{
              if(k == key){
                  if(currentSkuVariant.hasOwnProperty(`${k}`)){
                     s += `${k}_${item.getAttribute("id")}`;
                  }
              }else{
                if(currentSkuVariant.hasOwnProperty(`${k}`)){
                  s += `${k}_${currentSkuVariant[k]}`;
                }
              }
            })
            if (!variantKeyMap.hasOwnProperty(s)) {
                try {
                    let id = item.getAttribute('id');
                    document.querySelector(`div[id="t_${id}"]`).style.color = '#ccc';
                } catch (e) { }
            }
        });
    }
}

function variantInit() {
  productJson.options.forEach((key, index) => {
    currentSkuVariant[`${key}`] = productJson.variants[0].options[index];
    document
      .querySelectorAll(".rio-options span[type='" + key + "']")
      .forEach((item) => {
        item.classList.remove("active");
        if (item.getAttribute("id") == productJson.variants[0].options[index]) {
          item.classList.add("active");
        }
      });
  });
}

function variantSelect(key, value,cancel=false) {
  console.log("variantSelect:" + key + " " + value);
  document
    .querySelectorAll(".rio-options span[type='" + key + "']")
    .forEach((item) => {
      item.classList.remove("active");
      if (!cancel && item.getAttribute("id") == value) {
        item.classList.add("active");
      }
    });
}

function openModal(){
  let fontSize = isMobile?1.3:1.5;
  let marginTopBottom = isMobile?25:50;
  let html = `<div style="width: 86%;margin: ${marginTopBottom}px auto;/* color: #000; */padding: 0 10px;">
      <p style="text-align: left;color: #000;font-size: ${fontSize}rem;">We are dedicated to produce
jewelry in precious metal and 
high-quality material.</p>
     <p style="
    font-size: ${fontSize}rem;
    text-align: left;
">* Sterling Silver (S925)<br>
  Content of pure silver≥92.5%</p>
    <p style="
    text-align: left;
    font-size: ${fontSize}rem;
">* Tarnish-Resistant Silver(S180)<br>
  Content of pure silver≥18%</p>
</div>`;
  let width = isMobile?$(window).width()*0.8:350;
  let height = isMobile?255:350;
  
layer.open({
      type: 1,
      title:'',
      skin: 'layui-layer-rim', //加上边框
      area: [`${width}px`, `${height}px`], //宽高
     content: html
   });
}
const  product_collection_config = {
  
}

function openBraceletModal(){
  let fontSize = isMobile?1.3:1.5;
  let marginTopBottom = isMobile?20:50;
  let img = 'https://cdn.shopify.com/s/files/1/0783/2734/9558/files/Bracelet_Circumference_1.jpg?v=1706003971';
  let html = `<div style="width: 100%;margin: ${marginTopBottom}px auto;/* color: #000; */padding: 5px 2px;">
      <img src="${img}" style="width:100%;"/>
</div>`;
  let width = isMobile?$(window).width()*0.98:700;
  let height = isMobile?500:700;
  
layer.open({
      type: 1,
      title:'',
      skin: 'layui-layer-rim', //加上边框
      area: [`${width}px`, `${height}px`], //宽高
      content: html,
      offset: '125px',
   });
}



function open4c(){
  let fontSize = isMobile?1.3:1.5;
  let marginTopBottom = isMobile?20:50;
  let img = 'https://cdn.shopify.com/s/files/1/0549/2051/1688/files/417A3DD8-EA23-2CD4-8AC3-843F97E11B6F.png?v=1713768041';
  let html = `<div style="width: 100%;margin: ${marginTopBottom}px auto;/* color: #000; */padding: 5px 2px;">
      <img src="${img}" style="width:100%;"/>
</div>`;
  let width = isMobile?$(window).width()*0.98:700;
  let height = isMobile?500:700;
  
layer.open({
      type: 1,
      title:'',
      skin: 'layui-layer-rim', //加上边框
      area: [`${width}px`, `${height}px`], //宽高
      content: html,
      offset: '125px',
   });
}



function needSizingHelp(){
  let fontSize = isMobile?1.3:1.5;
  let marginTopBottom = isMobile?20:50;
  let html = `<style type="text/css">
	.contentCTitle{
		text-align: left;
		font-family: "hc";
		font-size: 20px;
		margin-top: 20px;
	}
	.contentCInfo{
		text-align: left;
		line-height: 18px;
		margin-top: 20px;
		font-family: "hc-light";
		font-size: 12px;
	}

	#horTableBox{
		width: 100%;
		border-collapse: collapse;
	}

	#horTableBox th, #horTableBox td {
		border: 1px solid #D4D4D4;
		text-align: center;
	}



	#ringSizeGuideTotalBox{
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
		text-align: center;
		margin-top: 25px;
	}

	#ringSizeGuideTotalBoxLeft{
		float: left;
		width: 172px;
		border-right: 1px solid #D4D4D4;
	}
	#ringSizeGuideTotalBoxLeft div{
		box-sizing: border-box;
		border-top: 1px solid #D4D4D4;
		border-left: 1px solid #D4D4D4;
		padding: 10px;
	}
	#ringSizeGuideTotalBoxRight{
		width: calc(100% - 175px);
		height: auto;
		overflow-x: auto;
		float: left;
	}

	.lie01l{
		width: 85px;
		float: left;
		font-size: 13px;
		color: #2C2C2C;

	}
	.lie01r{
		width: 85px;
		float: left;
		font-size: 13px;
		color: #2C2C2C;
	}
	.rightHeader{
		box-sizing: border-box;
		padding: 10px;
		width: 150xp;
		height: 80px;
		float: left;
		font-size: 14px;
		font-weight: 700;
		border-top: 1px solid #D4D4D4;
		border-right: 1px solid #D4D4D4;
	}

	.ringSizeGuideTotalBoxRightContent{
		height: auto;
	}
	.ringSizeGuideTotalBoxRightContent div{
		float: left;
		border-top: 1px solid #D4D4D4;
		border-right: 1px solid #D4D4D4;
		box-sizing: border-box;
		padding: 10px;
		font-size: 13px;
	}
	.ringSizeGuideTotalBoxRightContent div:nth-child(1) {
		width: 130px;
	}
	.ringSizeGuideTotalBoxRightContent div:nth-child(2) {
		width: 220px;
	}
	.ringSizeGuideTotalBoxRightContent div:nth-child(3) {
		width: 80px;
	}
	.ringSizeGuideTotalBoxRightContent div:nth-child(4) {
		width: 150px;
	}
	.ringSizeGuideTotalBoxRightContent div:nth-child(5) {
		width: 220px;
	}
	.ringSizeGuideTotalBoxRightContent div:nth-child(6) {
		width: 220px;
	}

	.contentCInfoUl{
		font-family: "hc-light";
	}



</style>


<div style="width:96%;margin: 0 auto;">

<div class="contentCTitle">Ring Size Chart</div>
<div class="contentCInfo">All of our rings are crafted in standard US sizes. View the chart below to see how US sizes map to finger circumference and convert to international sizes. Engagement rings, wedding bands, and fashion rings all follow the same size format.</div>


<div id="ringSizeGuideTotalBox">
	<div style="width：100%;text-align: center;margin-bottom: 5px;color: #888888;font-size: 13px;">Swipe to view more countries</div>
	<div id="ringSizeGuideTotalBoxLeft">
		<div style="width: 100%;font-size: 14px;font-weight: 700;height: 40px;">Inside Circumference</div>
			<div class="lie01l" style="font-size: 14px;font-weight: 700;height: 40px;">IN</div>
			<div class="lie01r" style="font-size: 14px;font-weight: 700;height: 40px;">MM</div>
			<div class="lie01l">1.74</div><div class="lie01r">44.2</div>
			<div class="lie01l">1.77</div><div class="lie01r">44.8</div>
			<div class="lie01l">1.79</div><div class="lie01r">45.5</div>
			<div class="lie01l">1.82</div><div class="lie01r">46.1</div>
			<div class="lie01l">1.84</div><div class="lie01r">46.8</div>
			<div class="lie01l">1.87</div><div class="lie01r">47.4</div>
			<div class="lie01l">1.89</div><div class="lie01r">48</div>
			<div class="lie01l">1.92</div><div class="lie01r">48.7</div>
			<div class="lie01l">1.94</div><div class="lie01r">49.3</div>
			<div class="lie01l">1.97</div><div class="lie01r">50</div>
			<div class="lie01l">1.99</div><div class="lie01r">50.6</div>
			<div class="lie01l">2.02</div><div class="lie01r">51.2</div>
			<div class="lie01l">2.04</div><div class="lie01r">51.9</div>
			<div class="lie01l">2.07</div><div class="lie01r">52.5</div>
			<div class="lie01l">2.09</div><div class="lie01r">53.1</div>
			<div class="lie01l">2.12</div><div class="lie01r">53.8</div>
			<div class="lie01l">2.14</div><div class="lie01r">54.4</div>
			<div class="lie01l">2.17</div><div class="lie01r">55.1</div>
			<div class="lie01l">2.19</div><div class="lie01r">55.7</div>
			<div class="lie01l">2.22</div><div class="lie01r">56.3</div>
			<div class="lie01l">2.24</div><div class="lie01r">57</div>
			<div class="lie01l">2.27</div><div class="lie01r">57.6</div>
			<div class="lie01l">2.29</div><div class="lie01r">58.3</div>
			<div class="lie01l">2.32</div><div class="lie01r">58.9</div>
			<div class="lie01l">2.34</div><div class="lie01r">59.5</div>
			<div class="lie01l">2.37</div><div class="lie01r">60.2</div>
			<div class="lie01l">2.39</div><div class="lie01r">60.8</div>
			<div class="lie01l">2.42</div><div class="lie01r">61.4</div>
			<div class="lie01l">2.44</div><div class="lie01r">62.1</div>
			<div class="lie01l">2.47</div><div class="lie01r">62.7</div>
			<div class="lie01l">2.49</div><div class="lie01r">63.4</div>
			<div class="lie01l">2.52</div><div class="lie01r">64</div>
			<div class="lie01l">2.54</div><div class="lie01r">64.6</div>
			<div class="lie01l">2.57</div><div class="lie01r">65.3</div>
			<div class="lie01l">2.59</div><div class="lie01r">65.9</div>
			<div class="lie01l">2.62</div><div class="lie01r">66.6</div>
			<div class="lie01l">2.65</div><div class="lie01r">67.2</div>
			<div class="lie01l">2.68</div><div class="lie01r">68.1</div>
			<div class="lie01l">2.71</div><div class="lie01r">68.5</div>
			<div class="lie01l">2.72</div><div class="lie01r">69.1</div>
			<div class="lie01l" style="border-bottom: 1px solid #D4D4D4;">2.75</div><div class="lie01r" style="border-bottom: 1px solid #D4D4D4;">69.7</div>
	</div>
	<div id="ringSizeGuideTotalBoxRight">
		<div style="width:1020px;">
			<div class="rightHeader" style="width:130px;display: flex;align-items: center;justify-content: center;">US, Canada, Mexico</div>
			<div class="rightHeader" style="width:220px;display: flex;align-items: center;justify-content: center;">UK, Australia, Ireland, New Zealand, South Africa</div>
			<div class="rightHeader" style="width:80px;display: flex;align-items: center;justify-content: center;">France</div>
			<div class="rightHeader" style="width:150px;display: flex;align-items: center;justify-content: center;">Germany, Russia, Ukraine, Asia</div>
			<div class="rightHeader" style="width:220px;display: flex;align-items: center;justify-content: center;">India, China, Japan, South America, Turkey, Israel</div>
			<div class="rightHeader" style="width:220px;display: flex;align-items: center;justify-content: center;">Italy, Spain, Netherlands, Switzerland</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>3</div><div>F</div><div>44</div><div>14</div><div>4</div><div>4</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>3.25</div><div>F 1/2</div><div>44.625</div><div>14.25</div><div>---</div><div>4.625</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>3.5</div><div>G</div><div>45.25</div><div>14.5</div><div>5</div><div>5.25</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>3.75</div><div>G 1/2</div><div>45.875</div><div>14.75</div><div>6</div><div>5.875</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>4</div><div>H</div><div>46.5</div><div>15</div><div>7</div><div>6.5</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>4.25</div><div>H 1/2</div><div>47.125</div><div>15.25</div><div>---</div><div>7.125</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>4.5</div><div>I</div><div>47.75</div><div>15.5</div><div>8</div><div>7.75</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>4.75</div><div>J</div><div>48.375</div><div>---</div><div>---</div><div>8.375</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>5</div><div>J 1/2</div><div>49</div><div>15.75</div><div>9</div><div>9</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>5.25</div><div>K</div><div>49.625</div><div>16</div><div>---</div><div>9.625</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>5.5</div><div>K 1/2</div><div>50.25</div><div>16.25</div><div>10</div><div>10.25</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>5.75</div><div>L</div><div>50.875</div><div>---</div><div>11</div><div>10.875</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>6</div><div>L 1/2</div><div>51.5</div><div>16.5</div><div>12</div><div>11.5</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>6.25</div><div>M</div><div>52.125</div><div>16.75</div><div>---</div><div>12.125</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>6.5</div><div>M 1/2</div><div>52.75</div><div>17</div><div>13</div><div>12.75</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>6.75</div><div>N</div><div>53.375</div><div>---</div><div>---</div><div>13.375</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>7</div><div>N 1/2</div><div>54</div><div>17.25</div><div>14</div><div>14</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>7.25</div><div>O</div><div>54.625</div><div>17.5</div><div>---</div><div>14.625</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>7.5</div><div>O 1/2</div><div>55.25</div><div>17.75</div><div>15</div><div>15.25</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>7.75</div><div>P</div><div>55.875</div><div>---</div><div>---</div><div>15.875</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>8</div><div>P 1/2</div><div>56.5</div><div>18</div><div>16</div><div>16.5</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>8.25</div><div>Q</div><div>57.125</div><div>18.25</div><div>---</div><div>7.125</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>8.5</div><div>Q 1/2</div><div>57.75</div><div>18.5</div><div>17</div><div>17.75</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>8.75</div><div>R</div><div>58.375</div><div>18.75</div><div>---</div><div>18.375</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>9</div><div>R 1/2</div><div>59</div><div>19</div><div>18</div><div>19</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>9.25</div><div>S</div><div>59.625</div><div>19.25</div><div>---</div><div>19.625</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>9.5</div><div>S 1/2</div><div>60.25</div><div>19.5</div><div>19</div><div>20.25</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>9.75</div><div>T</div><div>60.875</div><div>19.75</div><div>---</div><div>20.875</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>10</div><div>T 1/2</div><div>61.5</div><div>20</div><div>20</div><div>21.25</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>10.25</div><div>U</div><div>62.125</div><div>20.25</div><div>21</div><div>22.125</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>10.5</div><div>U 1/2</div><div>62.75</div><div>20.5</div><div>22</div><div>22.75</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>10.75</div><div>V</div><div>63.375</div><div>---</div><div>---</div><div>23.375</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>11</div><div>V 1/2</div><div>64</div><div>20.75</div><div>23</div><div>24</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>11.25</div><div>W</div><div>64.625</div><div>---</div><div>---</div><div>24.625</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>11.5</div><div>W 1/2</div><div>65.25</div><div>21</div><div>24</div><div>25.25</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>11.75</div><div>X</div><div>65.875</div><div>---</div><div>---</div><div>25.875</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>12</div><div>X 1/2</div><div>66.5</div><div>21.25</div><div>25</div><div>26.5</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>12.25</div><div>Y</div><div>67.125</div><div>21.5</div><div>---</div><div>27.125</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>12.5</div><div>Z</div><div>67.75</div><div>21.75</div><div>26</div><div>27.75</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div>12.75</div><div>Z 1/2</div><div>68.375</div><div>---</div><div>---</div><div>28.375</div>
		</div>

		<div class="ringSizeGuideTotalBoxRightContent" style="width:1020px;">
			<div style="border-bottom: 1px solid #D4D4D4;">13</div><div style="border-bottom: 1px solid #D4D4D4;">---</div><div style="border-bottom: 1px solid #D4D4D4;">69</div><div style="border-bottom: 1px solid #D4D4D4;">22</div><div style="border-bottom: 1px solid #D4D4D4;">27</div><div style="border-bottom: 1px solid #D4D4D4;">29</div>
		</div>
	</div>
</div>


<div style="width：100%;text-align: center;margin-bottom: 15px;margin-bottom: 15px;color: #888888;font-size: 13px;">Swipe to view more countries</div>



<div class="contentCTitle" style="font-size:25px;">Ring sizing tips</div>
<div class="contentCTitle">When choosing a ring size</div>
<div class="contentCInfo">If you’re wondering how Pandora rings should fit, we can help. Choose the ring size of the largest finger you’ll be wearing the ring on. When measuring, round to the closest whole millimetre. Ideally, a ring should be able to fit well enough so that it won’t fall off. However, you don’t want it to get stuck, so make sure it’s also loose enough to fit over your knuckle relatively easily.</div>

<div class="contentCTitle">Take measurements throughout the day</div>
<div class="contentCInfo">It’s important to remember that finger size changes throughout the day and can be affected by things like weather and hydration. We recommend measuring your finger several times over a day to calculate your ideal ring size.</div>

<div class="contentCTitle">Choose a larger size</div>
<div class="contentCInfo">Considering that your finger size changes throughout the day, it’s always best to choose a ring that’s slightly too large rather than slightly too small. You don’t want to risk getting it stuck on your finger.</div>

<div class="contentCTitle">Stackable rings</div>
<div class="contentCInfo">For stackable rings, select one size up from your normal ring size for a looser fit.</div>

<div class="contentCTitle">Wide shank rings</div>
<div class="contentCInfo">For wide shank rings, we recommend going one size larger than your normal ring size, as this ring has a wider band.

</div>


<div class="contentCTitle" style="font-size:25px;">Finding Out Someone Else’s Ring Size</div>
<div class="contentCInfo">Want to surprise a loved one with a beautiful ring? The first step to finding their perfect piece of jewelry is figuring out their ring size. There are a few ways you can do this without raising any suspicion.</div>


<div class="contentCTitle">Check their jewelry</div>
<div class="contentCInfo">One of the easiest ways to find out someone else’s ring size is to check their other jewelry. Take a peek inside their jewelry box and analyze the rings they already have. Use a ruler to measure the diameter of a couple of the rings. That way, you’ll have enough information to closely guess your loved one’s ring size.</div>

<div class="contentCTitle">Use a piece of string</div>
<div class="contentCInfo">While it may be tricky, using a piece of string is a great way to measure ring size if you’re buying for a partner.</div>
<div class="contentCInfo">Wrap a small piece of string around your partner’s finger while they’re sleeping and use a pen to mark where the ends meet. Take the string to a jeweler and you’ll receive an accurate measurement of ring size.</div>

<div class="contentCTitle">Ask friends or family</div>
<div class="contentCInfo">Encourage your loved one to try on their friends’ or family members’ rings so you can get a better idea of what their ring size might be.</div>



</div>`;
  let width = isMobile?$(window).width()*0.98:700;
  let height = isMobile?500:700;
  
layer.open({
      type: 1,
      title:'',
      skin: 'layui-layer-rim', //加上边框
      area: [`${width}px`, `${height}px`], //宽高
      content: html,
      offset: '125px',
   });
}

